module.exports = __webpack_public_path__ + "static/media/vitaminsBottle2.be1331a5.png";